export const USER_ROLES = ['admin', 'organizer', 'player'] as const;
export type UserRole = (typeof USER_ROLES)[number];

/** Higher number = more privileges. */
export const ROLE_LEVEL: Record<UserRole, number> = {
  player: 1,
  organizer: 2,
  admin: 3,
};

export function hasRoleAtLeast(role: UserRole | null | undefined, required: UserRole): boolean {
  if (!role) return false;
  return ROLE_LEVEL[role] >= ROLE_LEVEL[required];
}

export const SERIES_FORMATS = ['bo1', 'bo3', 'bo5'] as const;
export type SeriesFormat = (typeof SERIES_FORMATS)[number];

export const SERIES_STATUSES = ['draft', 'veto', 'live', 'finished', 'cancelled'] as const;
export type SeriesStatus = (typeof SERIES_STATUSES)[number];

export const TEAMS = ['a', 'b'] as const;
export type Team = (typeof TEAMS)[number];

export function otherTeam(team: Team): Team {
  return team === 'a' ? 'b' : 'a';
}

export const SIDES = ['attack', 'defense'] as const;
export type Side = (typeof SIDES)[number];

export function otherSide(side: Side): Side {
  return side === 'attack' ? 'defense' : 'attack';
}

export const VETO_ACTIONS = ['ban', 'pick', 'decider'] as const;
export type VetoAction = (typeof VETO_ACTIONS)[number];

export const SERIES_MAP_STATUSES = ['pending', 'played', 'not_played'] as const;
export type SeriesMapStatus = (typeof SERIES_MAP_STATUSES)[number];

export const PICKED_BY = ['a', 'b', 'decider'] as const;
export type PickedBy = (typeof PICKED_BY)[number];

export const RANK_SOURCES = ['manual', 'api'] as const;
export type RankSource = (typeof RANK_SOURCES)[number];

/** Regions supported by Riot / HenrikDev. */
export const REGIONS = ['eu', 'na', 'ap', 'kr', 'latam', 'br'] as const;
export type Region = (typeof REGIONS)[number];

/** Riot keeps separate ranked data per platform; HenrikDev needs it in the URL. */
export const PLATFORMS = ['pc', 'console'] as const;
export type Platform = (typeof PLATFORMS)[number];
export const DEFAULT_PLATFORM: Platform = 'console';

export const AGENT_ROLES = ['Duelist', 'Initiator', 'Controller', 'Sentinel'] as const;
